var _excluded = ["component", "size", "variant", "children", "className", "name", "src", "content", "srcSet", "crossOrigin", "referrerPolicy"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Tooltip } from '@creditas-ui/tooltip';
import { AvatarElement, AvatarImage, BackgroundColor } from './Avatar.style';
import { Placeholder } from './Placeholder';
import { useLoaded } from './useAvatar';

var Avatar = _ref => {
  var {
    component = 'span',
    size = 'md',
    variant = 'light',
    children,
    className,
    name,
    src,
    content,
    srcSet,
    crossOrigin,
    referrerPolicy
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var isLoaded = useLoaded({
    src,
    crossOrigin,
    referrerPolicy,
    srcSet
  });
  var tooltip = /*#__PURE__*/React.createElement(AvatarElement, _extends({}, props, {
    as: component,
    className: className,
    size: size,
    variant: variant
  }), /*#__PURE__*/React.createElement(BackgroundColor, {
    variant: variant
  }), isLoaded !== 'loaded' && /*#__PURE__*/React.createElement(Placeholder, {
    name: name,
    variant: variant,
    size: size
  }), isLoaded === 'loaded' && /*#__PURE__*/React.createElement(AvatarImage, {
    alt: name,
    src: src,
    srcSet: srcSet,
    crossOrigin: crossOrigin,
    referrerPolicy: referrerPolicy
  }));
  if (!content && !name) return tooltip;
  return /*#__PURE__*/React.createElement(Tooltip, {
    variant: variant,
    content: content || name,
    local: "bottom"
  }, tooltip);
};

export { Avatar };
//# sourceMappingURL=Avatar.js.map